import { Component, Host, h, Prop, Element, Watch } from '@stencil/core';
import * as echarts from 'echarts';

type EChartsOption = echarts.EChartsOption;

export interface ChartData {
  value: number;
  name: string;
}


const defaultOptions: EChartsOption = {

  title: [{
    text: '',
    left: 'center'
  }],
  tooltip: {
    trigger: 'item'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    align: 'auto'
  },
  series: [
    {
      type: 'pie',
      radius: '80%',
      clockwise: true,
      startAngle: 90,
      data: [],
      avoidLabelOverlap: true,
      center: ['50%', '50%'],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      },
      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay: function () {
        return Math.random() * 200;
      }
    },

  ]
};

@Component({
  tag: 'cr-pie-chart',
  styleUrl: 'cr-pie-chart.css',
  shadow: true,
})

export class CrPieChart {
  chartDom: any;
  eChart: echarts.ECharts;
  width: string = '500px';
  height: string = '500px';
  chartOptions: EChartsOption = defaultOptions;

  @Element() el: HTMLElement;

  @Prop() chartTitle: string = ""
  @Prop() radius: string = "75%"
  @Prop() clockWise: boolean = true
  @Prop() startAngle: number | string = 0
  @Prop() chartData: ChartData[] = []


  @Watch('chartTitle')
  @Watch('radius')
  @Watch('clockWise')
  @Watch('startAngle')
  @Watch('chartData')
  updateChart(newValue, oldValue) {
    if (Array.isArray(newValue)) {
      this.setChartData()
    } else {
      if (newValue !== oldValue)
        this.setChartAttributes()
    }
  }

  connectedCallback() {
    this.width = this.el.parentElement.style.width || this.el.parentElement.clientWidth + 'px';
    this.height = this.el.parentElement.style.height || this.el.parentElement.clientHeight + 'px';
  }

  componentDidLoad() {
    this.eChart = echarts.init(this.chartDom);
    this.setChartData()
    this.setChartAttributes()
  }

  render() {
    return (
      <Host>
        <div style={{ height: this.height, width: this.width }} ref={el => (this.chartDom = el as HTMLDivElement)}></div>
      </Host>
    );
  }

  private setChartData = () => {
    this.chartOptions.series[0].data = this.chartData
    this.eChart.setOption(this.chartOptions)
  }

  private setChartAttributes = () => {
    this.chartOptions.title[0].text = this.chartTitle
    this.chartOptions.series[0].radius = this.radius
    this.chartOptions.series[0].clockWise = this.clockWise
    this.chartOptions.series[0].startAngle = this.startAngle
    this.eChart.setOption(this.chartOptions)

  }
}
